import _orderBy from 'lodash/orderBy'
import {
  fetchHSECategories,
  fetchHSEPriorities,
  patchHSEPriorityById,
  saveHSEPriority,
} from 'frontend/communications/hse'
import { PROMISE_STATUS } from 'frontcore/constants/promises'
import { sortAlphabetically } from 'frontcore/utils/helpers/formatters'

const stateObj = {
  HSECategories: [],
  HSEPriorities: [],
  hseCategoriesPromise: null,
  hsePrioritiesPromise: null,
  hseCategoriesLoadingStatus: PROMISE_STATUS.notStarted,
  hsePrioritiesLoadingStatus: PROMISE_STATUS.notStarted,
}

const getters = {
  getActiveHSECategoriesAndException: (state) => (exception) => {
    return state.HSECategories.filter(category => {
      return category.enabled || category.id === exception
    }).sort(
      sortAlphabetically('name')
    )
  },
  getActiveHSEPrioritiesAndException: (state) => (exception) => {
    return _orderBy(state.HSEPriorities.filter(category => {
      return category.enabled || category.id === exception
    }), [function (priority) { return priority.deadline_days }], ['desc'])
  },
  getHSECategories (state) {
    return state.HSECategories
  },
  getHSEPriorities (state) {
    return _orderBy(state.HSEPriorities, [function (priority) { return priority.deadline_days }], ['desc'])
  },
  getHSECategoryById: (state) => (id) => {
    return state.HSECategories.find(category => category.id === id)
  },
  getHSEPriorityById: (state) => (id) => {
    return state.HSEPriorities.find(priority => priority.id === id)
  },
  hseCategoriesAreLoaded (state) {
    return state.hseCategoriesLoadingStatus === PROMISE_STATUS.complete
  },
  hsePrioritiesAreLoaded (state) {
    return state.hsePrioritiesLoadingStatus === PROMISE_STATUS.complete
  },
}

const mutations = {
  setHSECategories (state, categories) {
    state.HSECategories = categories
  },
  setHSEPriorities (state, priorities) {
    state.HSEPriorities = priorities
  },
  addHSEPriority (state, value) {
    const index = state.HSEPriorities.findIndex(priority => priority.id == value.id)
    index >= 0 ? state.HSEPriorities.splice(index, 1, value) : state.HSEPriorities.push(value)
  },
  setHseCategoriesLoadingStatus (state, status) {
    state.hseCategoriesLoadingStatus = status
  },
  setHsePrioritiesLoadingStatus (state, status) {
    state.hsePrioritiesLoadingStatus = status
  },
}

const actions = {
  fetchHSECategories ({ commit, state }, force=false) {
    if (state.hseCategoriesPromise == null || force) {
      state.hseCategoriesPromise = fetchHSECategories()
      commit('setHseCategoriesLoadingStatus', PROMISE_STATUS.pending)
    }
    return state.hseCategoriesPromise
      .then((categories) => {
        commit('setHSECategories', categories)
      })
      .catch(e => {
        state.hseCategoriesPromise = null
        throw e
      })
      .finally(() => {
        commit('setHseCategoriesLoadingStatus', PROMISE_STATUS.complete)
      })
  },
  fetchHSEPriorities ({ commit, state }, force=false) {
    if (state.hsePrioritiesPromise == null || force) {
      state.hsePrioritiesPromise = fetchHSEPriorities()
      commit('setHsePrioritiesLoadingStatus', PROMISE_STATUS.pending)
    }
    return state.hsePrioritiesPromise
      .then((priorities) => {
        commit('setHSEPriorities', priorities)
      })
      .catch(e => {
        state.hsePrioritiesPromise = null
        throw e
      })
      .finally(() => {
        commit('setHsePrioritiesLoadingStatus', PROMISE_STATUS.complete)
      })
  },
  createHSEPriority ({ commit }, payload ) {
    return saveHSEPriority(payload)
      .then((response) => {
        commit('addHSEPriority', response)
      })
  },
  updateHSEPriorityById ({ commit }, payload) {
    const { id, data } = payload
    return patchHSEPriorityById(id, data)
      .then((response) => {
        commit('addHSEPriority', response)
      })
  },
}

export default {
  actions,
  getters,
  mutations,
  state: stateObj,
}
